import "./App.css";
import artworkRequestManager from "../../data/remote/artworkRequestManager";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setNewMetadata } from "../../domain/slices/metadataSlice";
import { RootState } from "../../store/store";
import { BASE_URL } from "../../domain/model/API";
import { toMetadataFileName } from "../../data/utils/toMetadataFileName";

function App() {
  const dispatch = useDispatch();
  const metadata = useSelector((state: RootState) => state.metadata);
  const artworkRef = useRef<HTMLImageElement>(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    audioRef.current = new Audio("https://n227.ozelip.com/7774/stream");
    audioRef.current.loop = false;

    return () => {
      audioRef?.current?.pause();
      audioRef.current = null;
    };
  }, []); // csak egyszer fusson le

  useEffect(() => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying]);

  useEffect(() => {
    let isMounted = true;
    artworkRequestManager({
      delegate: ({ artist, title, artWork }) => {
        // console.log(artWork);
        if (isMounted) {
          dispatch(
            setNewMetadata({
              artist,
              title,
              artwork: toMetadataFileName(artist, title),
            }),
          );
        }
      },
    });
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return (
    <div className="App">
      <header className="App-header">
        <img src={"default.png"} height={"80vh"} alt="logo" />
      </header>
      <img
        ref={artworkRef}
        src={
          metadata.artwork === "default.png"
            ? metadata.artwork
            : `${BASE_URL}artwork/${metadata.artwork}`
        }
        onError={() => {
          if (artworkRef.current && artworkRef.current.src !== "default.png") {
            artworkRef.current.src = "default.png";
          }
        }}
        width={300}
        alt="artwork"
      />
      <p>
        <strong>{metadata.artist}</strong>
      </p>
      <p>{metadata.title}</p>
      <div onClick={() => setIsPlaying(!isPlaying)}>
        <img
          className="play-button"
          src={isPlaying ? "stop.png" : "play.png"}
          alt="play btn"
          width={120}
        />
      </div>
      <iframe
        src="https://player.twitch.tv/?channel=xmusic_official&parent=www.xmusic.hu"
        frameBorder="0"
        allowFullScreen={true}
        scrolling="no"
        height="378"
        width="620"
        style={{ marginTop: 30 }}
      ></iframe>
    </div>
  );
}

export default App;
